export default __webpack_public_path__ + "static/media/ic_favorites.31643415.svg";